export default {"src":"/_next/static/media/veeIcon.f388cbe2.svg","height":32,"width":33,"blurWidth":0,"blurHeight":0};